export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    tagline: "Perfect for individuals and small teams exploring AI automation",
    price: 2999,
    currency: "INR",
    billingCycle: "month",
    razorpayPlanId: process.env.REACT_APP_RAZORPAY_PLAN_STARTER,
    highlighted: false,
    features: [
      "1 AI Agent deployment",
      "Up to 5 automated workflows",
      "1,000 workflow executions/month",
      "Pre-built agent templates",
      "Basic analytics dashboard",
      "API access (100 req/hr)",
      "Email support (48h response)",
      "Data retention: 30 days",
    ],
  },
  {
    id: "professional",
    name: "Professional",
    tagline: "For growing teams that need multiple agents and scale",
    price: 7999,
    currency: "INR",
    billingCycle: "month",
    razorpayPlanId: process.env.REACT_APP_RAZORPAY_PLAN_PROFESSIONAL,
    highlighted: true,
    badge: "Most Popular",
    features: [
      "Up to 10 AI Agent deployments",
      "Unlimited workflows",
      "50,000 workflow executions/month",
      "Custom agent training (upload documents)",
      "Advanced analytics + custom reports",
      "API access (1,000 req/hr)",
      "Webhook integrations (Slack, Zapier, Make)",
      "Priority support — 8h response + live chat",
      "Up to 5 user seats",
      "Data retention: 90 days",
      "SLA: 99.5% uptime",
    ],
  },
  {
    id: "enterprise",
    name: "Enterprise",
    tagline: "Unlimited power, white-label, and dedicated support",
    price: 19999,
    currency: "INR",
    billingCycle: "month",
    razorpayPlanId: process.env.REACT_APP_RAZORPAY_PLAN_ENTERPRISE,
    highlighted: false,
    features: [
      "Unlimited AI Agent deployments",
      "Unlimited workflows & executions",
      "Custom AI model fine-tuning",
      "White-label (your domain & branding)",
      "Custom integrations (ERP, CRM, SAP)",
      "Unlimited API access",
      "Unlimited user seats",
      "Dedicated account manager + phone support",
      "GSTIN-compliant invoices",
      "Data retention: 1 year",
      "SLA: 99.9% uptime",
      "On-premise deployment option",
    ],
  },
];

export const PLAN_ORDER = ["free", "starter", "professional", "enterprise"];

export const getPlanById = (id) => PLANS.find((p) => p.id === id);
